import { Link } from 'react-router-dom';
import { categories } from '@/mocks/gallery';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-foreground-100">
      <div className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-camera-lens-line text-xl text-primary-400"></i>
              </span>
              <span className="text-lg font-bold font-heading text-white whitespace-nowrap">
                美女图精选
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              汇聚高清唯美写真、时尚人像摄影与艺术风格美图。每日更新，满足你对美的一切想象与欣赏需求。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">风格分类</h4>
            <ul className="flex flex-col gap-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">快速链接</h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                  联系我们
                </Link>
              </li>
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">
                  常见问题
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">关注我们</h4>
            <div className="flex items-center gap-3 mb-4">
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors"
                aria-label="小红书"
                rel="nofollow"
              >
                <i className="ri-reddit-line text-lg"></i>
              </a>
            </div>
            <p className="text-sm text-foreground-300">
              邮箱：contact@meinvtu.com
            </p>
            <p className="text-sm text-foreground-300">
              微信：meinvtu-official
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 美女图精选合集 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">用户协议</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors whitespace-nowrap">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}